import * as React from "react";
import ConsentForms from "../ConsentForms/ConsentForms";
import styles from "./ConfigurationsWrapper.module.scss";
import { cn } from "../../../../helpers";
import ManageLocations from "../ManageLocations/ManageLocations";
import ManageClinicianServices from "../ManageClinicianServices/ManageClinicianServices";
import ManageDepartmentServices from "../ManageDepartmentServices/ManageDepartmentServices";

export default function ConfigurationsWrapper() {
    type TabItem = {
        key: string;
        title: React.ReactNode;
        component: React.ReactNode;
        show?: boolean;
    };

    const [activeKey, setActiveKey] = React.useState<string>("locations");

    const tabs: TabItem[] = [
        {
            key: "locations",
            title: "Locations",
            component: <ManageLocations />,
            show: true,
        },
        {
            key: "clinician-services",
            title: "Clinician's Services",
            component: <ManageClinicianServices />,
            show: true,
        },
        {
            key: "department-services",
            title: "Department & Services",
            component: <ManageDepartmentServices />,
            show: true,
        },
        {
            key: "consent-forms",
            title: "Consent Form Links",
            component: <ConsentForms />,
            show: true,
        },
    ];

    const tabsToShow = tabs.filter((t) => t.show);

    const getActiveComponent = () => {
        const activeTab = tabsToShow.find((tab) => tab.key === activeKey);
        return activeTab?.component || null;
    };

    return (
        <div className={cn(styles.layoutWrapper, "v2-page")}>
            <div className={styles.sidebar}>
                <div className={styles.card}>
                    <div className={styles.tabGroup}>
                        {tabsToShow.map((tab) => (
                            <div
                                key={tab.key}
                                className={`${styles.tabItem} ${
                                    activeKey === tab.key ? styles.tabItemActive : ""
                                }`}
                                onClick={() => setActiveKey(tab.key)}
                            >
                                <div>{tab.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className={styles.mainContent}>{getActiveComponent()}</div>
        </div>
    );
}
